//logic for playing a video via embedded YouTube block
document.querySelectorAll( '.yt-player' ).forEach( player => {
	const playBtn           = player.querySelector( '.play-button' )
	const placeholderImg    = player.querySelector( '.placeholder-img' )
	const videoPlayer       = player.querySelector( '.video-source' )
	const iFrameElem        = player.querySelector( 'iframe' )

	const hide = function (elem) {
		elem.style.display = 'none'
	};

	const show = function (elem) {
		elem.style.display = 'block'
	};

	if ( playBtn ) {

		playBtn.addEventListener( 'click', e => {
			e.preventDefault()

			player.classList.add( 'play-video' )

			hide(playBtn)

			if ( placeholderImg ) {
				hide(placeholderImg)
			}

			if ( videoPlayer ) {
				show(videoPlayer)
				iFrameElem.src = iFrameElem.src + '&autoplay=1' // add parameter to url for autostart
			}
		})
	}
})